import { showProgressModal } from 'global/modal/progressModal';

export function returnWithBasket() {
	const buttonId = 'placeRequisition';
	$(`#${buttonId}`).click(() => {
		showProgressModal();
	});
}
